module.exports = __webpack_public_path__ + "img/punto2.114f0b90.png";